"use client"

import styled from "@emotion/styled"
import Script from "next/script"

const ELFSIGHT_ID = "elfsight-app-01ee3bdc-4f29-4d78-88b3-a34b331e34ee"

const StyledSection = styled.section`
  display: flex;
  width: 100%;
  overflow: hidden;
`

const PortInstagramFeed = () => {
  return (
    <StyledSection>
      <Script src="https://elfsightcdn.com/platform.js" strategy="lazyOnload" />
      <div className={ELFSIGHT_ID} data-elfsight-app-lazy />
    </StyledSection>
  )
}
export default PortInstagramFeed
